import {
    Props,
} from 'mk2/apps/strollers/containers/StrollerProductPhotosGallery/StrollerProductPhotosGalleryPage';
import { strollersPhotoUrl, strollersVariantPhotoUrl } from 'mk2/apps/strollers/urls';
import { ImgCropped, ImgCropMode } from 'mk2/components/ImgCropped';
import { Link } from 'mk2/components/Link';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './StrollerProductPhotosGallery.mscss';

interface State {
    imagesDivWidth: number;
}

export class StrollerProductPhotosGallery extends React.Component<Props, State> {

    private imagesDivRef: React.RefObject<HTMLDivElement> = React.createRef();

    constructor(props: Props) {
        super(props);
        this.state = {
            imagesDivWidth: null,
        };
    }

    public componentDidMount() {
        if (this.imagesDivRef.current) {
            this.setState({ imagesDivWidth: this.imagesDivRef.current.clientWidth});
        }
    }

    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.imagesDivRef.current && !this.state.imagesDivWidth) {
            this.setState({ imagesDivWidth: this.imagesDivRef.current.clientWidth});
        }
    }

    public render() {
        const { loadingState } = this.props;

        return (
            <div className={styles.StrollerProductPhotosGallery} ref={this.imagesDivRef}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    hasData={false}
                />
            </div>
        );
    }

    private renderSuccess = () => {
        const { images, stroller, strollerVariantId } = this.props;
        const imagesDivWidth = this.imagesDivRef?.current?.clientWidth || 600;
        const imageSize = Math.floor((imagesDivWidth - 10) / 4) - 2;
        return (
            <div className={styles.StrollerProductPhotosGallery__images}>
                {images.map((image, idx) => {
                    return (
                        <Link
                            to={!!strollerVariantId ? url(strollersVariantPhotoUrl, {
                                slug: stroller.slug,
                                variantId: strollerVariantId,
                                photoId: image.id,
                            })
                            : url(strollersPhotoUrl, {
                                slug: stroller.slug,
                                photoId: image.id,
                            })}
                            key={`photo-${idx}`}
                        >
                            <div className={styles.StrollerProductPhotosGallery__image}>
                                <ImgCropped
                                    mode={ImgCropMode.Cover}
                                    imgUrl={image.original}
                                    imgWidth={image.width}
                                    imgHeight={image.height}
                                    width={imageSize}
                                    height={imageSize}
                                />
                            </div>
                        </Link>
                    );
                })}
            </div>
        );
    };

    private load = () => {
        const { strollerSlug, strollerVariantId, onLoad } = this.props;

        if (!!strollerVariantId) {
            onLoad(strollerSlug, strollerVariantId);
        } else {
            onLoad(strollerSlug);
        }
    };
}
